import React from 'react';
import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';

const createReactClass = require('create-react-class');

const SearchFilterMenu = createReactClass({
  handleFilterSelected(filter_value, e) {
    // this.refs.filterArrow.style.left = e.target.style.left;
    this.props.filterSelected(filter_value);
  },
  render() {
    let sortedFilters = [];
    sortedFilters = this.props.filterOrder.map(
      function(key, index) {
        let selected = '';
        if (this.props.currentFilter == key) {
          selected = 'selected';
        }
        const filtersKey = this.props.filters[key];
        const filterString = StringConstantsMixin.stringsLookup(StringConstantsMixin.strings.SEARCH_TAB_NAMES, filtersKey);
        return (
          <li className={selected} onClick={this.handleFilterSelected.bind(null, key)} key={index}>
            {filterString}
          </li>
        );
      }.bind(this)
    );
    return (
      <div className="action-bar lighter search-box clearfix">
        <menu className="title clearfix filter-menu tabs">{sortedFilters}</menu>
      </div>
    );
  }
});

export { SearchFilterMenu };
